import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'
const BusinessIntelligenceApplications = ({ rawUrl }) => {
    var aaa = readUrl();
    const [state, setState] = useState(aaa);

    const pageTitle = `Best Bio Matrics ERP Software ${state.condText} | ERP Systems | Business Management Solutions - Tejaxo Software`;
    const metaDescription = `Tejaxo Software is a High Rated Indian Bio Matrics ERP Software ${state.condText}, providing award-winning Enterprise Resource Planning (ERP) software, business management solutions, services and support.`;
    const metaKeywords = `Tejaxo Bio Matrics ERP Software ${state.condText}, Tejaxo Bio Matrics ERP, ERP Software, Tejaxo Bio Matrics Software`;

   
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                {/* Row 1: Image */}
                <div className="row">
                    <img src="/theme/img/bdimg13.JPG" alt="Tejaxo Bio Matrics" />
                </div>
                <br />

                {/* Row 2: Heading and Image */}
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <h2 className="elementor-heading-title elementor-size-default">
                            Instant access to accurate data is one of the key ways to secure a competitive advantage.
                        </h2>
                    </div>
                    <div className="col-lg-6 content">
                        <img src="/theme/img/bdimg14.JPG" alt="Business Insights" />
                    </div>
                </div>
                <br />

                {/* Row 3: Image and Content */}
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="/theme/img/applications-768x512.jpg" alt="Applications" />
                    </div>
                    <div className="col-lg-6 content">
                        <h3 className="elementor-heading-title elementor-size-default">
                            Tejaxo iQ, our Business Intelligence division, helps you visualise and analyse data gathered in Tejaxo Xi across your operations.
                        </h3>
                        <p>
                            <span style={{ fontWeight: 400 }}>
                                This delivers the actionable insights needed to drive certainty in strategic, real-time decision-making. Built on IBM Cognos Analytics technology, the detailed, interactive reports created can be consumed on the web and other mobile devices.
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default BusinessIntelligenceApplications;